(() => {
  function init(root = document) {
    for (const host of root.querySelectorAll('[data-mb-native-reviews]')) {
      if (host.dataset.mbReady) continue;
      const list = host.querySelector('[data-mb-review-list]');
      if (!list) continue;
      const items = [...list.children];
      const filter = host.querySelector('[data-mb-review-filter]');
      const sort = host.querySelector('[data-mb-review-sort]');
      const more = host.querySelector('[data-mb-review-more]');
      const status = host.querySelector('[data-mb-review-status]');
      if (!filter || !sort || !more || !status) continue;
      host.dataset.mbReady = 'true';
      sort.value = 'newest';
      let limit = 5;
      const render = () => {
        const order = [...items].sort((a,b) => {
          const date = b.dataset.mbReviewDate.localeCompare(a.dataset.mbReviewDate);
          const rating = Number(a.dataset.mbReviewRating) - Number(b.dataset.mbReviewRating);
          return sort.value === 'oldest' ? -date : sort.value === 'lowest' ? rating || date : sort.value === 'highest' ? -rating || date : date;
        });
        const matching = order.filter(item => filter.value === 'all' || item.dataset.mbReviewRating === filter.value);
        const shown = new Set(matching.slice(0,limit));
        order.forEach(item => { item.hidden = !shown.has(item); list.append(item); });
        more.hidden = matching.length <= limit;
        status.textContent = matching.length ? host.dataset.mbStatusTemplate.replace('[shown]', String(shown.size)).replace('[total]', String(matching.length)) : host.dataset.mbEmptyStatus;
      };
      host.querySelector('.mb-native-controls').hidden = false;
      filter.addEventListener('change',()=>{limit=5;render();});
      sort.addEventListener('change',()=>{limit=5;render();});
      more.addEventListener('click',()=>{limit+=5;render();});
      render();
    }
  }
  window.MartenbrownReviews = { init };
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('click',event=>{
    const link=event.target.closest('.mb-native-rating[data-mb-open-reviews]');
    if(!link)return;
    const details=document.getElementById(link.dataset.mbOpenReviews);
    if(details){details.open=true;details.querySelector('summary')?.focus({preventScroll:true});}
  });
})();
